exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "td{\r\n    vertical-align: middle;\r\n}\r\n\r\nth{\r\n    text-align: center;\r\n}\r\n\r\n.hidden{\r\n    display:none;\r\n}\r\n\r\n.width-30{\r\n    width:30%;\r\n}\r\n\r\n.bws-thumb{\r\n    width:100px;\r\n    height:100px;\r\n    -o-object-fit: cover;\r\n       object-fit: cover;\r\n    border:2px solid #000;\r\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// E:/UniServerZ/www/seo/wp-content/plugins/dvin508-ada-seo/seo/src/app/post/post.component.css
// module id = ../../../../../src/app/post/post.component.css
// module chunks = main